// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.date-picker-container {
  width: 100%;
  position: relative;
}
.date-picker-container__content {
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  color: #757575;
  gap: 10px;
}
.date-picker-container__content--input {
  width: 100%;
  height: 40px;
  border: var(--m-default-border);
  border-radius: var(--m-border-radius);
  transition: var(--m-transition-fast);
  padding: 0 35px 0 12px;
  outline: none;
  background-color: var(--m-sidebar-background-color);
  color: var(--m-text-muted);
  -webkit-user-select: none;
  user-select: none;
}
.date-picker-container__content--input:focus, .date-picker-container__content--input:hover {
  border-color: var(--m-primary);
}
.date-picker-container__content--input::placeholder {
  color: var(--m-text-muted);
}
.date-picker-container__content--input--no-focus {
  border-color: var(--m-primary);
  pointer-events: none;
}
.date-picker-container__content--input--invalid {
  border-color: var(--m-danger-xbolder);
}
.date-picker-container__content--input--valid {
  border-color: var(--m-success-xbolder);
}
.date-picker-container__content--label {
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  color: var(--m-text);
}
.date-picker-container__content--label--required {
  color: var(--m-danger-xbolder);
  padding-left: 3px;
}
.date-picker-container__content--icon {
  font-size: 18px;
  cursor: pointer;
  position: absolute;
  right: 12px;
  top: 38px;
  color: var(--m-text-muted);
}
.date-picker-container__content--no-label {
  top: 21px;
}
.date-picker-container__content .content-message {
  position: absolute;
  bottom: 0;
  margin-bottom: -25px;
  font-size: 13px;
}
.date-picker-container__content .content-message--valid {
  color: var(--m-success-xbolder);
}
.date-picker-container__content .content-message--invalid {
  color: var(--m-danger-xbolder);
}
.date-picker-container__selector {
  width: 100%;
  min-width: 270px;
  max-width: 300px;
  display: none;
  transition: display ease-in-out 0.6s;
  position: absolute;
  left: 0;
  z-index: var(--m-z-index-dropdown);
  box-shadow: var(--m-box-shadow);
  border: 1px solid var(--m-border-color);
}
.date-picker-container__selector--visible {
  display: block;
}
.date-picker-container__selector--dropup {
  bottom: 40px;
  box-shadow: 0px -5px 5px -5px rgba(18, 38, 63, 0.03), -5px 0px 5px -5px rgba(18, 38, 63, 0.03), 5px 0px 5px -5px rgba(18, 38, 63, 0.03);
}`, "",{"version":3,"sources":["webpack://./src/components/CustomUI/DatePicker/DatePicker.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,kBAAA;AACF;AAEE;EACE,WAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,cAAA;EACA,SAAA;AAAJ;AAEI;EACE,WAAA;EACA,YAAA;EACA,+BAAA;EACA,qCAAA;EACA,oCAAA;EACA,sBAAA;EACA,aAAA;EACA,mDAAA;EACA,0BAAA;EACA,yBAAA;EAGA,iBAAA;AAAN;AAEM;EAEE,8BAAA;AADR;AAoBM;EACE,0BAAA;AANR;AASM;EACE,8BAAA;EACA,oBAAA;AAPR;AAUM;EACE,qCAAA;AARR;AAWM;EACE,sCAAA;AATR;AAaI;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;AAXN;AAaM;EACE,8BAAA;EACA,iBAAA;AAXR;AAeI;EACE,eAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,0BAAA;AAbN;AAgBI;EACE,SAAA;AAdN;AAiBI;EACE,kBAAA;EACA,SAAA;EACA,oBAAA;EACA,eAAA;AAfN;AAiBM;EACE,+BAAA;AAfR;AAkBM;EACE,8BAAA;AAhBR;AAqBE;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,oCAAA;EACA,kBAAA;EACA,OAAA;EACA,kCAAA;EACA,+BAAA;EACA,uCAAA;AAnBJ;AAqBI;EACE,cAAA;AAnBN;AAsBI;EACE,YAAA;EACA,uIAAA;AApBN","sourcesContent":[".date-picker-container {\n  width: 100%;\n  position: relative;\n  // margin-bottom: 16px;\n\n  &__content {\n    width: 100%;\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    color: #757575;\n    gap: 10px;\n\n    &--input {\n      width: 100%;\n      height: 40px;\n      border: var(--m-default-border);\n      border-radius: var(--m-border-radius);\n      transition: var(--m-transition-fast);\n      padding: 0 35px 0 12px;\n      outline: none;\n      background-color: var(--m-sidebar-background-color);\n      color: var(--m-text-muted);\n      -webkit-user-select: none;\n      -moz-user-select: none;\n      -ms-user-select: none;\n      user-select: none;\n\n      &:focus,\n      &:hover {\n        border-color: var(--m-primary);\n      }\n\n      &::-webkit-input-placeholder {\n        color: var(--m-text-muted);\n      }\n\n      &::-moz-placeholder {\n        color: var(--m-text-muted);\n      }\n\n      &:-ms-input-placeholder {\n        color: var(--m-text-muted);\n      }\n\n      &::-ms-input-placeholder {\n        color: var(--m-text-muted);\n      }\n\n      &::placeholder {\n        color: var(--m-text-muted);\n      }\n\n      &--no-focus {\n        border-color: var(--m-primary);\n        pointer-events: none;\n      }\n\n      &--invalid {\n        border-color: var(--m-danger-xbolder);\n      }\n\n      &--valid {\n        border-color: var(--m-success-xbolder);\n      }\n    }\n\n    &--label {\n      font-size: 12px;\n      font-weight: 600;\n      line-height: 16px;\n      color: var(--m-text);\n\n      &--required {\n        color: var(--m-danger-xbolder);\n        padding-left: 3px;\n      }\n    }\n\n    &--icon {\n      font-size: 18px;\n      cursor: pointer;\n      position: absolute;\n      right: 12px;\n      top: 38px;\n      color: var(--m-text-muted);\n    }\n\n    &--no-label {\n      top: 21px;\n    }\n\n    .content-message {\n      position: absolute;\n      bottom: 0;\n      margin-bottom: -25px;\n      font-size: 13px;\n\n      &--valid {\n        color: var(--m-success-xbolder);\n      }\n\n      &--invalid {\n        color: var(--m-danger-xbolder);\n      }\n    }\n  }\n\n  &__selector {\n    width: 100%;\n    min-width: 270px;\n    max-width: 300px;\n    display: none;\n    transition: display ease-in-out 0.6s;\n    position: absolute;\n    left: 0;\n    z-index: var(--m-z-index-dropdown);\n    box-shadow: var(--m-box-shadow);\n    border: 1px solid var(--m-border-color);\n\n    &--visible {\n      display: block;\n    }\n\n    &--dropup {\n      bottom: 40px;\n      box-shadow: 0px -5px 5px -5px rgba(18, 38, 63, 0.03),\n        -5px 0px 5px -5px rgba(18, 38, 63, 0.03),\n        5px 0px 5px -5px rgba(18, 38, 63, 0.03);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
